import { Component, OnInit } from '@angular/core';
import { ConnectionService } from '../../connection.service';
import { Router, ActivatedRoute, ParamMap } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
	selector: 'app-transactiondetails',
	templateUrl: './transactiondetails.component.html',
	styleUrls: ['./transactiondetails.component.css']
})
export class TransactiondetailsComponent implements OnInit {
	txhis: any; fee: any; txid;
	transactionInfo: any;
	transactionTime: number;
	timeString: string = '';
	SrVoteInfo: any;
	voteTime: number;

	constructor(private conn: ConnectionService, private alert: ToastrService, private actRoute: ActivatedRoute, private route: Router, private spinner: NgxSpinnerService) {
		this.txid = this.actRoute.snapshot.params['txid']
	}

	ngOnInit() {
		this.getTransInfo()
		setTimeout(() => {
			this.calculateTimeRemaining()
		}, 2000)
	}

	getTransInfo() {
		this.conn.postUrl('users/getTransDetails', { transactionId: this.txid }).subscribe((resp: any) => {
			this.spinner.show()
			if (resp.success == true) {
				this.spinner.hide()
				this.transactionInfo = resp.data[0]
				this.transactionTime = new Date(this.transactionInfo.updated_at).getTime()
			}
		})
	}


	calculateTimeRemaining() {
		const currentTime = new Date().getTime();
		
			const timeDifference = currentTime - this.transactionTime;
			if (timeDifference > 0) {
				const hours = Math.floor((timeDifference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
				const minutes = Math.floor((timeDifference % (1000 * 60 * 60)) / (1000 * 60));
				const seconds = Math.floor((timeDifference % (1000 * 60)) / 1000);
				this.timeString = `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
				setTimeout(() => {
					this.calculateTimeRemaining();
				}, 1000);
			} else {
				// this.timeString = 'Timer expired!';
			}
	}

	copyText(val: string) {
		let selBox = document.createElement('input');
		selBox.value = val;
		document.body.appendChild(selBox);
		selBox.focus();
		selBox.select();
		document.execCommand('copy');
		document.body.removeChild(selBox);
		window.scrollTo(0, 0);
		this.alert.success('Copied to the clipboard');
	}

}
